import ProfileAddContainer from '../../containers/profile/ProfileAddContainer'

const ProfileAddPage = () => {
  return <ProfileAddContainer />
}

export default ProfileAddPage
